import { AuthorizationCodeGrant, centralizedAuth } from '@cimpress/simple-auth-wrapper';

export const auth = new centralizedAuth({
  clientID: import.meta.env.VITE_CLIENT_ID,
  redirectRoute: '/',
});

/**
 * Creates the authorization-code grant used to register or refresh the user's subscription authorization.
 *
 * @param redirectRoute Route Auth0 redirects back to after the grant, e.g. `/dashboard`.
 * @returns A grant configured with the notifications client ID.
 */
export const createAuthorizationCodeGrant = (redirectRoute: string) =>
  new AuthorizationCodeGrant({
    clientID: import.meta.env.VITE_NOTIFICATIONS_CLIENT_ID,
    redirectRoute,
  });
